import React from 'react'
import AboutV2 from "../components/aboutv2/AboutV2"

export default function AboutPage() {
  return (
    <> <AboutV2 /> </>
  )
}
